import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { environment } from "../../../environments/environment";
import { GenericResponseDto } from "../models/generic-response.dto";
import { UnusedPersonnelNumber } from "../models/profile/unusedPersonnelNumber";
import { UnusedProject } from "../models/profile/unusedProject";
import { GetUserDto } from "../models/users/users/getUserDto";
import { UpdateUserDto } from "../models/users/users/UpdateUserDto";
import { ConfirmUserEmailDto } from "../models/users/users/confirmUserEmailDto";

@Injectable({
  providedIn: "root",
})
export class UserProfileService {
  private userManagementBaseURL = environment.baseUrl + "/User";
  private commonBaseURL = environment.baseUrl + "/Common";

  constructor(private _http: HttpClient) {}

  getUsersById(id: number): Observable<GenericResponseDto<GetUserDto>> {
    return this._http.get<GenericResponseDto<GetUserDto>>(
      this.userManagementBaseURL + "/GetUserbyId?id=" + id
    );
  }

  updateUser(
    payload: UpdateUserDto
  ): Observable<GenericResponseDto<UpdateUserDto>> {
    return this._http.put<GenericResponseDto<UpdateUserDto>>(
      this.userManagementBaseURL + "/UpdateUser",
      payload
    );
  }

  getUserAccessJsonData() {
    return this._http.get("assets/userProfileSecurityMapping.json");
  }

  getUnusedPhoneNumber(
    userid: string
  ): Observable<GenericResponseDto<UnusedPersonnelNumber[]>> {
    return this._http.get<GenericResponseDto<UnusedPersonnelNumber[]>>(
      this.commonBaseURL + `/UnusedPersonnelNumbers?userid=${userid}`
    );
  }

  getUnusedProject(
    userid: string
  ): Observable<GenericResponseDto<UnusedProject[]>> {
    return this._http.get<GenericResponseDto<UnusedProject[]>>(
      this.commonBaseURL + `/UnusedProjects/?userid=${userid}`
    );
  }

  confirmEmail(
    payload: ConfirmUserEmailDto
  ): Observable<GenericResponseDto<string>> {
    return this._http.put<GenericResponseDto<string>>(
      this.userManagementBaseURL + `/ConfirmUserEmail`,
      payload
    );
  }
}
